import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export type HttpErrorDto = {
  reason?: string;
  errors: HttpErrorItemDto[];
  instance: string;
  status: HttpStatusCode;
  type: string;
  traceId: string;
  title: string;
};

type HttpErrorItemDto = {
  name: string;
  reason: string;
  code: string;
};

const isHttpErrorItemDto = (value: unknown): value is HttpErrorItemDto => {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as HttpErrorItemDto;
  return (
    typeof candidate.name === 'string' && typeof candidate.reason === 'string'
  );
};

export const isHttpErrorDto = (value: unknown): value is HttpErrorDto => {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as HttpErrorDto;
  return (
    typeof candidate.reason === 'string' ||
    (Array.isArray(candidate.errors) &&
      candidate.errors.every(isHttpErrorItemDto))
  );
};

export const getErrorMessage = (
  errorResponse: HttpErrorResponse
): string | string[] | null => {
  const error = errorResponse.error;
  if (!isHttpErrorDto(error)) {
    console.error('No error message found in response', errorResponse);
    return null;
  }
  if (error.reason) return [error.reason];
  if (Array.isArray(error.errors)) {
    return error.errors.map((item) => item.reason);
  }
  console.error('No error message found in response', errorResponse);
  return null;
};

export const getFirstErrorMessage = (
  error: HttpErrorResponse
): string | null => {
  const res = getErrorMessage(error);
  if (Array.isArray(res)) {
    return res.find((message) => message.trim().length > 0) ?? null;
  }
  if (typeof res === 'string' && res.trim().length > 0) return res;
  return null;
};
